import { ProjectModel } from '../models';

export interface AcceptanceEmail {
	isAcceptance: boolean;
	project: ProjectModel;
}
